import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Modal as ReactstrapModal, ModalBody, ModalHeader } from 'reactstrap';
import { connect } from 'react-redux';
import { createPallet, getPallets } from '../../state/services/extraService';
import { toast } from 'react-toastify';
import { API_HOST, HTTP_PROTOCOL } from '../../config';

class PalletCartonModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editingPalletType: {},
            selectedPallets: [],
        };
    }

    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        toggleModal: PropTypes.func.isRequired,
        bookingId: PropTypes.object.isRequired,
        getPallets: PropTypes.func.isRequired,
        createPallet: PropTypes.func.isRequired,
        pallets: PropTypes.array,
        onRepack: PropTypes.func.isRequired,
    };

    static defaultProps = {
        isOpen: false,
    };

    componentDidMount() {
        this.refreshPallets();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen === true) {
            this.refreshPallets();
        }
    }

    refreshPallets = () => {
        this.props.getPallets();
    };

    handleEditPalletType = (pallet) => {
        if (pallet !== null) {
            this.setState({
                editingPalletType: pallet,
            });
        } else {
            this.setState({
                editingPalletType: {
                    id: null,
                    desc: '',
                    length: 0,
                    width: 0,
                    height: 0,
                    weight: 0,
                    type: 0,
                },
            });
        }
    };

    handleInputChange = (event, field) => {
        event.preventDefault();
        if (field === 'is_pallet') {
            this.setState({
                editingPalletType: {
                    ...this.state.editingPalletType,
                    [field]: event.target.value === 'true',
                },
            });
        } else {
            this.setState({
                editingPalletType: {
                    ...this.state.editingPalletType,
                    [field]: event.target.value,
                },
            });
        }
    };

    handleSave = () => {
        const { editingPalletType } = this.state;
        if (!editingPalletType.length) {
            toast.warn('Please input Length');
            return;
        }
        if (!editingPalletType.width) {
            toast.warn('Please input Width');
            return;
        }
        if (!editingPalletType.height) {
            toast.warn('Please input Height');
            return;
        }
        if (!editingPalletType.weight) {
            toast.warn('Please input Weight');
            return;
        }

        const token = localStorage.getItem('token');
        let options = {
            method: editingPalletType.id ? 'put' : 'post',
            url:
                HTTP_PROTOCOL +
                '://' +
                API_HOST +
                '/pallet/' +
                (editingPalletType.id ? `${editingPalletType.id}/` : ''),
            headers: { Authorization: 'JWT ' + token },
            data: editingPalletType,
        };

        axios(options)
            .then(() => {
                toast.success('Saved successfully.');
                this.setState({ editingPalletType: {} });
                this.refreshPallets();
            })
            .catch((error) => {
                toast.error('Failed - ' + error);
            });
    };

    handleCancel = () => {
        this.setState({
            editingPalletType: {},
        });
    };

    handleCheckbox = (event, pallet) => {
        if (event.target.checked) {
            this.setState({
                selectedPallets: [...this.state.selectedPallets, pallet],
            });
        } else {
            this.setState({
                selectedPallets: this.state.selectedPallets.filter(
                    (_pallet) => _pallet.id !== pallet.id
                ),
            });
        }
    };

    handleAddPallet = () => {
        this.setState({
            editingPalletType: {
                id: null,
                is_pallet: true
            },
        });
    };

    handleSelectAll = (allSelected) => {
        if (allSelected) {
            this.setState({ selectedPallets: [] });
        } else {
            this.setState({ selectedPallets: this.props.pallets });
        }
    };

    getPalletTableRow = (pallet) => {
        const { editingPalletType, selectedPallets } = this.state;
        if (pallet && editingPalletType.id !== pallet.id) {
            return (
                <React.Fragment>
                    <td>
                        <input
                            type='checkbox'
                            checked={selectedPallets.some(
                                (each) => each.id === pallet.id
                            )}
                            onChange={(event) =>
                                this.handleCheckbox(event, pallet)
                            }
                        />
                    </td>
                    <td>{pallet.desc}</td>
                    <td>{pallet.length}</td>
                    <td>{pallet.width}</td>
                    <td>{pallet.height}</td>
                    <td>{pallet.weight}</td>
                    <td>{pallet.is_pallet ? 'Pallet' : 'Not Pallet'}</td>
                    <td>
                        <div className='flex justify-center'>
                            <div
                                className='btn btn-primary'
                                onClick={() =>
                                    this.handleEditPalletType(pallet)
                                }
                            >
                                Edit
                            </div>
                        </div>
                    </td>
                </React.Fragment>
            );
        } else if (
            (!pallet && editingPalletType.id === null) ||
            (pallet && pallet.id === editingPalletType.id)
        ) {
            return (
                <React.Fragment>
                    <td></td>
                    <td>
                        <textarea
                            className='form-control mb-0'
                            type='text'
                            value={editingPalletType.desc || ''}
                            onChange={(event) =>
                                this.handleInputChange(event, 'desc')
                            }
                        />
                    </td>
                    <td>
                        <input
                            className='form-control mb-0'
                            type='number'
                            value={editingPalletType.length}
                            onChange={(event) =>
                                this.handleInputChange(event, 'length')
                            }
                        />
                    </td>
                    <td>
                        <input
                            className='form-control mb-0'
                            type='number'
                            value={editingPalletType.width}
                            onChange={(event) =>
                                this.handleInputChange(event, 'width')
                            }
                        />
                    </td>
                    <td>
                        <input
                            className='form-control mb-0'
                            type='number'
                            value={editingPalletType.height}
                            onChange={(event) =>
                                this.handleInputChange(event, 'height')
                            }
                        />
                    </td>
                    <td>
                        <input
                            className='form-control mb-0'
                            type='number'
                            value={editingPalletType.weight}
                            onChange={(event) =>
                                this.handleInputChange(event, 'weight')
                            }
                        />
                    </td>
                    <td>
                        <select
                            className='form-control mb-0'
                            type='number'
                            value={
                                editingPalletType.is_pallet
                            }
                            onChange={(event) =>
                                this.handleInputChange(event, 'is_pallet')
                            }
                        >
                            <option value={true}>Pallet</option>
                            <option value={false}>Not Pallet</option>
                        </select>
                    </td>
                    <td>
                        <div className='flex justify-center'>
                            <div
                                className='btn btn-success'
                                onClick={() => this.handleSave()}
                            >
                                Save
                            </div>
                            <div
                                className='btn btn-danger'
                                onClick={() => this.handleCancel()}
                            >
                                Cancel
                            </div>
                        </div>
                    </td>
                </React.Fragment>
            );
        } else {
            return null;
        }
    };

    handleRepack = () => {
        const { selectedPallets } = this.state;
        if (selectedPallets.length === 0) {
            toast.warn('Please select pallet types to repack.');
            return;
        }
        this.props.toggleModal();
        this.props.onRepack(selectedPallets.map(pallet => pallet.id));
    };

    render() {
        const { isOpen, pallets } = this.props;
        const { selectedPallets } = this.state;
        const allSelected = selectedPallets.length === pallets.length;
        return (
            <ReactstrapModal
                isOpen={isOpen}
                className='pallet-carton-modal'
                backdrop={true}
                size='xl'
                scrollable={true}
            >
                <ModalHeader toggle={this.props.toggleModal}>
                    Pallet/Carton Modal
                </ModalHeader>
                <ModalBody>
                    <div className='flex flex-col'>
                        <div className='flex overflow-auto'>
                            <table className='table table-striped text-center'>
                                <thead>
                                    <th className='text-center'>
                                        <input
                                            type='checkbox'
                                            checked={allSelected}
                                            onClick={() =>
                                                this.handleSelectAll(allSelected)
                                            }
                                        />
                                    </th>
                                    <th className='text-center'>Description</th>
                                    <th className='text-center'>Length(mm)</th>
                                    <th className='text-center'>Width(mm)</th>
                                    <th className='text-center'>Heigth(mm)</th>
                                    <th className='text-center'>Weight(kg)</th>
                                    <th className='text-center'>Is Pallet?</th>
                                    <th className='text-center'>Edit</th>
                                </thead>
                                <tbody>
                                    {pallets.map((pallet) => (
                                        <tr key={pallet.id}>
                                            {this.getPalletTableRow(pallet)}
                                        </tr>
                                    ))}
                                    <tr>{this.getPalletTableRow(null)}</tr>
                                </tbody>
                            </table>
                        </div>
                        <div className='flex justify-content-between'>
                            <div
                                className='btn btn-primary'
                                onClick={() => this.handleAddPallet()}
                            >
                                <i className='icon icon-plus' />
                                Add
                            </div>
                            <div
                                className='btn btn-warning'
                                onClick={() => this.handleRepack()}
                            >
                                Repack
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </ReactstrapModal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        pallets: state.extra.pallets,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPallets: () => dispatch(getPallets()),
        createPallet: (pallet) => dispatch(createPallet(pallet)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PalletCartonModal);



// WEBPACK FOOTER //
// ./src/components/CommonModals/PalletCartonModal.js